import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { environment } from '../../../../environments/environment';
import { OriginBuilder } from '../../models/builders/origin.builder';

@Injectable()
export class OriginApiService {
  private apiUrl: string;

  constructor(private httpClient: HttpClient) {
    this.apiUrl = `${ environment.apiUrl }origins`;
  }

  getModelOrigins(model: string) {
    const params = new HttpParams().append('model', model);

    return this.httpClient.get(`${ this.apiUrl }`, { params })
      .pipe(map(OriginBuilder.fromList));
  }
}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/services/api/origin-api.service.ts